import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  interfaceData: [],
  destinationTablesData: [],
  businessAdvisorMapsData: [],
  // { name, brands: [{ brand_id, brand_name }] } for the map last clicked
  businessAdvisorMapsToBrandsData: null,
  // every gap rule, filtered per row by destination table + target field
  gapRulesData: [],
};

const advisorSlice = createSlice({
  name: "advisor",
  initialState: initialState,
  reducers: {
    setInterfaceData: (state, action) => {
      state.interfaceData = action.payload;
    },
    setDestinationTablesData: (state, action) => {
      state.destinationTablesData = action.payload;
    },
    setBusinessAdvisorMapsData: (state, action) => {
      state.businessAdvisorMapsData = action.payload;
    },
    setBusinessAdvisorMapsToBrandsData: (state, action) => {
      state.businessAdvisorMapsToBrandsData = action.payload;
    },
    setGapRulesData: (state, action) => {
      state.gapRulesData = action.payload;
    },
  },
});

export const {
  setInterfaceData,
  setDestinationTablesData,
  setBusinessAdvisorMapsData,
  setBusinessAdvisorMapsToBrandsData,
  setGapRulesData,
} = advisorSlice.actions;

export default advisorSlice.reducer;
